import { createContext, type PropsWithChildren, useContext } from 'react';

import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

export type Dependencies = {
  repositories: {
    warranty: IWarrantyRepository;
  };
};

const DependenciesContext = createContext<Dependencies>(
  // @ts-expect-error - This is a placeholder value that should never be used
  null,
);

export function DependenciesProvider({
  children,
  dependencies,
}: PropsWithChildren<{
  dependencies: Dependencies;
}>) {
  return (
    <DependenciesContext.Provider value={dependencies}>
      {children}
    </DependenciesContext.Provider>
  );
}

export function useDependencies(): Dependencies {
  return useContext(DependenciesContext);
}
